<template>
  <Toast/>
  <div class="row">
    <div class="col titre">
      <h2>Localisation</h2>
    </div>
  </div>
  <CriteresRechercheLocalisation @rechercher="rechercher"/>
  <ResultatRechercheLocalisation :localisations="localisations" :isRechercheDataLoading="isRechercheDataLoading"
                                 @removeLocalisationFromList="removeLocalisationFromList"/>
</template>

<script>
import CriteresRechercheLocalisation
  from '../../../../components/pilotage/Fichiers/Localisation/CriteresRechercheLocalisation.vue'
import ResultatRechercheLocalisation
  from '../../../../components/pilotage/Fichiers/Localisation/ResultatRechercheLocalisation.vue'

import {mapGetters} from "vuex";
import axios from 'axios';

export default {
  components: {
    CriteresRechercheLocalisation,
    ResultatRechercheLocalisation
  },
  mounted() {
    this.$root.$refs.breadcrumbComp.ajout("Recherche Localisation");
    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.rechercher();
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
    }),
  },
  data() {
    return {
      localisations: [],
      isRechercheDataLoading: false
    }
  },
  methods: {
    rechercher() {
      this.isRechercheDataLoading = true;
      this.$store.dispatch("pilotage/rechercherLocalisationAction").then((res) => {
        this.localisations = res.data;
        this.isRechercheDataLoading = false;
      });
    },
    removeLocalisationFromList(cle) {
      this.localisations = this.localisations.filter(current => (current.cleLocalisation != cle))
    }
  }
}
</script>
